import * as yup from 'yup';
export const emlakBasvuruValidation = yup.object().shape({
  name: yup.string().when(
    'step', {
    is: 1,
    then: schema => schema.required("Zorunlu bir alandır")
  }
  ),
  surname: yup.string().when(
    'step', {
    is: 1,
    then: schema => schema.required("Zorunlu bir alandır")
  }
  ),
  age: yup.string().when(
    'step', {
    is: 2,
    then: schema => schema.required("Zorunlu bir alandır")
  }
  ),
  job: yup.string().when(
    'step', {
    is: 2,
    then: schema => schema.required("Zorunlu bir alandır")
  }
  ),
  about: yup.string().when(
    'step', {
    is: 3,
    then: schema => schema.required("Zorunlu bir alandır")
  }
  ),
})

export const isyeriRuhsatValidationSchema = yup.object({
  IacRuhsatBasvuruTuruId: yup.number().required("Başvuru Türü zorunludur."),
  mahalleKodu: yup.number().required().nullable(),
  caddeSokakKodu: yup.number().required().nullable(),
  kapiNo: yup.number().required().nullable(),
  altKapiNo: yup.string().nullable(),
  daireNo: yup.number().nullable(),
  altDaireNo: yup.string().nullable(),
  siteApartmanAdi: yup.string().nullable(),
  pafta: yup.string().nullable(),
  ada: yup.number().nullable(),
  parsel: yup.number().nullable(),
  vergiDairesiAdi: yup.string().required().nullable(),
  vergiDairesiNo: yup.number().required().nullable(),
  ticaretSicilNo: yup.number().required().nullable(),
  ustalikBelgeNo: yup.string().required().nullable(),
  isyeriSinifiKodu: yup.number().nullable(),
  binaKullanimTuruKodu: yup.number().nullable(),
  isyeriKonumuKodu: yup.number().nullable(),
  mulkiyetDurumuKodu: yup.number().required().nullable(),
  acikAlanM2: yup.number().nullable(),
  kapaliAlanM2: yup.number().nullable(),
  yazAcilisSaat: yup.string().nullable(),
  yazKapanisSaat: yup.string().nullable(),
  kisAcilisSaat: yup.string().nullable(),
  kisKapanisSaat: yup.string().nullable(),
  egitimUzaklik: yup.number().nullable(),
  dershaneUzaklik: yup.number().nullable(),
  ogrenciYurduUzaklik: yup.number().nullable(),
  ibadethaneUzaklik: yup.number().nullable(),
  aciklama: yup.string().nullable(),
});


export const binaBasvuruValidationSchema = yup.object({
  basvuruTuruId: yup.number().required('Başvuru türü zorunludur'),
  mahalleKodu: yup.number().required('Mahalle kodu zorunludur'),
  caddeSokakKodu: yup.number().required('Cadde/Sokak kodu zorunludur'),
  kapiNo: yup.string().required('Kapı no zorunludur').matches(/^\d+$/, 'Geçerli bir sayı olmalıdır'),
  altKapiNo: yup.string().matches(/^\d*$/, 'Geçerli bir sayı olmalıdır'),
  daireNo: yup.number().positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  altDaireNo: yup.string().matches(/^\d*$/, 'Geçerli bir sayı olmalıdır'),
  siteApartmanAdi: yup.string(),
  blokNo: yup.string(),
  katNo: yup.string(),
  pafta: yup.string().required('Pafta zorunludur'),
  ada: yup.number().required('Ada zorunludur').positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  parsel: yup.number().required('Parsel zorunludur').positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  tapuBlokNo: yup.string(),
  tapuKatNo: yup.string(),
  tapuCiltNo: yup.number().positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  tapuSayfaNo: yup.number().positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  tapuYevmiyeNo: yup.string(),
  tapuBagimsizNo: yup.string(),
  arsaYuzolcumu: yup.number().required('Arsa yüzölçümü zorunludur').positive('Sadece pozitif sayı olabilir'),
  arsaHisse: yup.number().required('Arsa hissesi zorunludur').positive('Sadece pozitif sayı olabilir'),
  arsaOran: yup.number().required('Arsa oranı zorunludur').positive('Sadece pozitif sayı olabilir'),
  arsa2Hisse: yup.number().required('Arsa 2 hissesi zorunludur').positive('Sadece pozitif sayı olabilir'),
  arsa2Oran: yup.number().required('Arsa 2 oranı zorunludur').positive('Sadece pozitif sayı olabilir'),
  binaYuzolcumu: yup.number().positive('Sadece pozitif sayı olabilir').required("Bina yüzölçümü zorunludur"),
  binaHisse: yup.number().required('Bina hissesi zorunludur').positive('Sadece pozitif sayı olabilir'),
  binaOran: yup.number().required('Bina oranı zorunludur').positive('Sadece pozitif sayı olabilir'),
  bina2Hisse: yup.number().positive('Sadece pozitif sayı olabilir'),
  bina2Oran: yup.number().positive('Sadece pozitif sayı olabilir'),
  insaatTuruKodu: yup.number().positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  insaatSinifiKodu: yup.number().positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  kullanimSekliKodu: yup.number().required('Kullanım şekli kodu zorunludur').positive('Sadece pozitif sayı olabilir').integer('Geçerli bir sayı olmalıdır'),
  tapuYevmiyeTarihi: yup.date().nullable(),
  insaatBitisTarihi: yup.date().nullable().required("İnşaat bitiş tarihi zorunludur"),
  edinmeTarihi: yup.date().required('Edinme tarihi zorunludur'),
  kaloriferliMi: yup.string().required('Kalorifer durumu zorunludur'),
  asansorluMu: yup.string().required('Asansör durumu zorunludur'),
  aciklama: yup.string(),
  pismanlikIndirimi: yup.string()
});


export const araziBasvuruValidationSchema = yup.object().shape({
  basvuruTuruId: yup
    .number()
    .required('Başvuru türü zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),

  mahalleKodu: yup
    .number()
    .required('Mahalle kodu zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  caddeSokakKodu: yup
    .number()
    .required('Cadde/Sokak kodu zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  mevki: yup.string().required('Mevki zorunludur'),
  pafta: yup.string().required('Pafta zorunludur'),
  ada: yup
    .number()
    .required('Ada zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  parsel: yup
    .number()
    .required('Parsel zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  tapuCiltNo: yup
    .number()
    .nullable()
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  tapuSayfaNo: yup
    .number()
    .nullable()
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  araziYuzolcumu: yup
    .number()
    .required('Arazi yüzölçümü zorunludur')
    .positive('Sadece pozitif sayı olabilir'),
  araziHisse: yup
    .number()
    .required('Arazi hissesi zorunludur')
    .positive('Sadece pozitif sayı olabilir'),
  araziOran: yup
    .number()
    .required('Arazi oranı zorunludur')
    .positive('Sadece pozitif sayı olabilir'),
  arazi2Hisse: yup
    .number()
    .nullable()
    .positive('Sadece pozitif sayı olabilir'),
  arazi2Oran: yup
    .number()
    .nullable()
    .positive('Sadece pozitif sayı olabilir'),
  araziTuru: yup
    .number()
    .required('Arazi türü zorunludur')
    .positive('Sadece pozitif sayı olabilir')
    .integer('Geçerli bir sayı olmalıdır'),
  edinmeTarihi: yup
    .date()
    .required('Edinme tarihi zorunludur'),
  aciklama: yup.string(),
  tapuYevmiyeTarihi: yup.date().nullable(),
  tapuYevmiyeNo: yup.string(),
  pismanlikIndirimi: yup.string(),
  imarPlanNo: yup.string(),
});


export const istekSikayetValidationSchema = yup.object().shape({
  adi: yup.string().required('Adı zorunludur'),
  soyadi: yup.string().required('Soyadı zorunludur'),
  tckimlikNo: yup
    .string()
    .required('T.C. Kimlik Numarası zorunludur'),
    //.matches(/^[0-9]{11}$/, 'T.C. Kimlik Numarası 11 haneli olmalıdır'),
  gsmKodu: yup.string(),
  cepTelefonu: yup.string()
  .required("Cep Telefonu zorunludur")
  .length(17, "Cep Telefonu 11 haneli olmalıdır."),
  ePostaAdresi: yup.string().email('Geçerli bir e-posta adresi giriniz').required('E-posta adresi zorunludur'),
  mahalleKodu: yup
    .number()
    .required('Mahalle Kodu zorunludur'),
  caddeSokakKodu: yup
    .number()
    .required('Cadde/Sokak Kodu zorunludur')
    .typeError('Cadde/Sokak Kodu sadece sayı olmalıdır'),
  basvuruNedeniKodu: yup
    .number()
    .required('Başvuru Nedeni Kodu zorunludur')
    .typeError('Başvuru Nedeni Kodu sadece sayı olmalıdır'),
  konuBasligiKodu: yup
    .number()
    .required('Konu Başlığı Kodu zorunludur')
    .typeError('Konu Başlığı Kodu sadece sayı olmalıdır'),
  basvuruMetni: yup.string().required('Başvuru Metni zorunludur'),
  basvuruTuruId: yup.number().nullable().typeError('Başvuru Türü sadece sayı olmalıdır'),
  alanKodu: yup.string().nullable(),
  sabitTelefon: yup.string().nullable(),
  ikametgahAdresi: yup.string().nullable(),
  belediyeSiniriIcindeMi: yup.string().nullable(),
  kapiNo: yup.number().nullable().typeError('Kapı No sadece sayı olmalıdır'),
  altKapiNo: yup.string().nullable(),
  daireNo: yup.number().nullable().typeError('Daire No sadece sayı olmalıdır'),
  altDaireNo: yup.string().nullable(),
  kimlikBilgilerimiGizle: yup.string().nullable(),
  smsBildirimiIstiyorum: yup.string().nullable(),
});


export const arsaBasvuruValidationSchema = yup.object({
  basvuruTuruId: yup.number().required('Başvuru türü zorunludur').positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  mahalleKodu: yup.number().required('Mahalle kodu zorunludur').nullable(),
  caddeSokakKodu: yup.number().required('Cadde/Sokak kodu zorunludur').nullable(),
  kapiNo: yup.number().required('Kapı no zorunludur').positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  pafta: yup.string().required('Pafta zorunludur'),
  ada: yup.number().required('Ada zorunludur').positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  parsel: yup.number().required('Parsel zorunludur').positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  mevki: yup.string(),
  blokNo: yup.string(),
  katNo: yup.string(),
  tapuBagimsizNo: yup.string(),
  altKapiNo: yup.string(),
  daireNo: yup.number().positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  altDaireNo: yup.string(),
  siteApartmanAdi: yup.string(),
  tapuCiltNo: yup.number().positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  tapuSayfaNo: yup.number().positive('Geçerli bir sayı olmalıdır').integer('Geçerli bir sayı olmalıdır'),
  arsaYuzolcumu: yup.number().required('Arsa yüzölçümü zorunludur').positive('Geçerli bir sayı olmalıdır'),
  arsaHisse: yup.number().required('Arsa hissesi zorunludur').positive('Geçerli bir sayı olmalıdır'),
  arsaOran: yup.number().required('Arsa oranı zorunludur').positive('Geçerli bir sayı olmalıdır'),
  arsa2Hisse: yup.number().positive('Geçerli bir sayı olmalıdır'),
  arsa2Oran: yup.number().positive('Geçerli bir sayı olmalıdır'),
  edinmeTarihi: yup.date().required('Edinme tarihi zorunludur'),
  aciklama: yup.string(),
  tapuYevmiyeTarihi: yup.date().nullable(),
  tapuYevmiyeNo: yup.string(),
  pismanlikIndirimi: yup.string(),

});
export const ilanReklamvalidationSchema = yup.object().shape({
  basvuruTuruId: yup.number().required('Başvuru Türü ID gereklidir'),
  butceGelirId: yup.number().required('Bütçe Gelir ID gereklidir'),
  vergiYili: yup.number().required('Vergi Yılı gereklidir'),
  ilanBaslamaTarihi: yup.date().required('İlan Başlama Tarihi gereklidir'),
  ilanBitisTarihi: yup.date().required('İlan Bitiş Tarihi gereklidir'),
  yerKodu: yup.number().required('Yer Kodu gereklidir'),
  mahalleKodu: yup.number().required('Mahalle Kodu gereklidir'),
  caddeSokakKodu: yup.number().required('Cadde/Sokak Kodu gereklidir'),
  kapiNo: yup.number().required('Kapı No gereklidir'),
  altKapiNo: yup.string(),
  daireNo: yup.number().required('Daire No gereklidir'),
  altDaireNo: yup.string(),
  blokKatNo: yup.string(),
  siteApartmanAdi: yup.string(),
  pafta: yup.string(),
  ada: yup.number(),
  parsel: yup.number(),
  aracPlaka: yup.string().required('Araç Plaka gereklidir'),
  aracSaseNo: yup.string().required('Araç Şase No gereklidir'),
  sponsorFirmaKodu: yup.number().required('Sponsor Firma Kodu gereklidir'),
  faaliyetKodu: yup.number().required('Faaliyet Kodu gereklidir'),
  eni: yup.number().when('adetM2', {
    is: "METREKARE",
    then: yup.number().required('Eni gereklidir'),
    otherwise: yup.number(),
  }),
  boyu: yup.number().when('adetM2', {
    is: "METREKARE",
    then: yup.number().required('Boyu gereklidir'),
    otherwise: yup.number(),
  }),
  kacYonlu: yup.number().when('adetM2', {
    is: "METREKARE",
    then: yup.number().required('Kaç Yönlü gereklidir'),
    otherwise: yup.number(),
  }),
  kacAdet: yup.number().when('adetM2', {
    is: "ADET",
    then: yup.number().required('Kaç Adet gereklidir'),
    otherwise: yup.number(),
  }),
  adetM2: yup.string(),
  aciklama: yup.string(),
});


export const katiAtikValidationSchema = yup.object().shape({
  basvuruTuruId: yup.number().required('Başvuru Türü ID gereklidir'),
  mahalleKodu: yup.number().required('Mahalle Kodu gereklidir'),
  caddeSokakKodu: yup.number().required('Cadde/Sokak Kodu gereklidir'),
  kapiNo: yup.number().required('Kapı No gereklidir'),
  altKapiNo: yup.string(),
  daireNo: yup.number().required('Daire No gereklidir'),
  altDaireNo: yup.string(),
  blokKatNo: yup.string(),
  siteApartmanAdi: yup.string(),
  pafta: yup.string(),
  ada: yup.number(),
  parsel: yup.number(),
  isyeriAcmaTarihi: yup.string().required('İş Yeri Açma Tarihi gereklidir'),
  faaliyetKodu: yup.number().required(),
  kullanimSekliKodu: yup.number().required(),
  kriterKodu: yup.number(),
  m2: yup.number().when('kriterKodu', {
    is: 1,
    then: yup.number().required('M2 gereklidir'),
    otherwise: yup.number(),
  }),
  ogrenciSayisi: yup.number().when('kriterKodu', {
    is: 3,
    then: yup.number().required('Öğrenci Sayısı gereklidir'),
    otherwise: yup.number(),
  }),
  koltukSayisi: yup.number().when('kriterKodu', {
    is: 5,
    then: yup.number().required('Koltuk Sayısı gereklidir'),
    otherwise: yup.number(),
  }),
  personelSayisi: yup.number().when('kriterKodu', {
    is: 2,
    then: yup.number().required('Personel Sayısı gereklidir'),
    otherwise: yup.number(),
  }),
  yatakSayisi: yup.number().when('kriterKodu', {
    is: 4,
    then: yup.number().required('Yatak Sayısı gereklidir'),
    otherwise: yup.number(),
  }),
  ctvGrup: yup.number(),
  ctvDerece: yup.number(),
  aciklama: yup.string(),
  kaloriferliMi: yup.string(),
});


